export default "__VITE_ASSET__BlvJeL_v__"